import { useFeatureFlags } from './useFeatureFlags';
import { useSportContext } from '../contexts/sport';

export const useQuickplayAssets = () => {
  const { sport } = useSportContext();
  const {
    flags: { useQuickplayAssetsPerSport = {} },
  } = useFeatureFlags();

  return useQuickplayAssetsPerSport[sport];
};
